<template>
	<span>
		<v-tooltip top>
			<template v-slot:activator="{ on }">
				<v-btn
					v-on="on"
					icon
					small
					:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
					@click.stop="dialog = true">
					<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params.color">{{ params.icon }}</v-icon>
				</v-btn>
			</template>
			<span>{{ params.text }}</span>
		</v-tooltip>

		<v-dialog v-model="dialog" max-width="600" persistent>
			<v-card class="background-2 round-card">
				<v-card-title primary-title class="subtitle-1 background-2">Reset Password</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-4 body-2" style="min-height: 100px;">
					Verrà generata una nuova password per <strong>{{ model.name }}</strong>.
					<v-checkbox
						v-model="sendEmail"
						label="Invia email con le nuove credenziali"
						hide-details
						class="mt-4"
					></v-checkbox>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" :disabled="loading" @click="dialog = false">Annulla</v-btn>
					<v-btn text color="info" :loading="loading" @click="reset">Conferma</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</span>
</template>

<script>
export default {
	name: 'portal-reset-password',
	props: {
		model: Object,
		params: Object,
		button: Object
	},
	data() {
		return {
			dialog: false,
			loading: false,
			sendEmail: true
		}
	},
	methods: {
		async reset() {
			this.loading = true
			try {
				const resp = await this.axios.post('portalusers/' + this.model.id + '/reset-password', {
					send_email: this.sendEmail
				})
				if (resp.data.success) {
					this.$store.commit('setSnackbar', {
						timeout: 4000,
						text: resp.data.message,
						value: true,
						color: 'success'
					})
				} else {
					this.$store.commit('setSnackbar', {
						timeout: 4000,
						text: resp.data.message || 'Errore',
						value: true,
						color: 'error'
					})
				}
			} catch (e) {
				this.$store.commit('setSnackbar', {
					timeout: 4000,
					text: e.response?.data?.message || 'Errore nel reset della password',
					value: true,
					color: 'error'
				})
			} finally {
				this.loading = false
				this.dialog = false
			}
		}
	}
}
</script>
